import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { play, stopPlay } from '../../store/InstructionStore';
import './Instructions.css';
import Menu from '../Menu';
import InstructionItem from './InstructionItem';
import InstructionPlayer from './InstructionPlayer';
import config from '../../config';



const Instructions = () => {
    const dispatch = useDispatch();
    const instructionState = useSelector(state => state.instructionState);
    const videos = instructionState.instructionVideos;

    const handlePlay = (index) => {
        dispatch(play(index));
    };

    const handleStopPlay = () => {
        dispatch(stopPlay());
    };

    return (
        <div className="App">
            <Menu className='menu instruction' />
            <div className='instruktions-container'>
                {videos.length !== 0 ? (
                    <div className='row'>
                        {videos.map((video, index) => (
                            <div className="column" key={index} onClick={() => handlePlay(index)}>
                                <InstructionItem
                                    path={config.server + video.path}
                                    type={video.type}
                                    name={video.name}
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div>
                        Ingen instruktions videoer fundet
                    </div>
                )}
                {instructionState.currentVideo !== null ? (
                    <div className='outer-video-container' onClick={handleStopPlay}>
                        <div className={'InstructionPlayer-container'}>
                            <InstructionPlayer
                                path={config.server + videos[instructionState.currentVideo].path}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default Instructions;